(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'app/utils/stringUtils', 'app/utils/routerUtils'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('underscore'), require('./utils/stringUtils'), require('./utils/routerUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(_, stringUtils, routerUtils) {
  'use strict';

  /**
   * Utility methods for determining specifics about the app that is currently being used to render the views.
   *
   * @class applicationUtils
   * @static
   */
  var serverRoot = window.location.protocol + '//' + window.location.host;
  function buildLoginUrl(loginRoot, serviceURLSuffix, redirectURL) {
    var loginUrl = loginRoot;
    loginUrl += '?service=' + encodeURIComponent(serverRoot + serviceURLSuffix);
    if (redirectURL) {
      var relativeUrl = redirectURL.replace(serverRoot, '');
      var cleanRedirectURL = routerUtils.cleanRedirectURL(relativeUrl);
      // I can't get this to work, tried this and url= and neither redirected.  This is only used for CAS authentication context.
      loginUrl += '&originalUrl=' + encodeURIComponent(cleanRedirectURL);
    }
    return loginUrl;
  }
  var APPLICATIONS = {
        ADMIN_TOOL: {
          name: 'ADMIN_TOOL',
          context: 'kiosk-workflows',
          baseRestUrl: '/kiosk-workflows/ws',
          baseSecureRestUrl: '/kiosk-workflows/ws',
          urlPath: '/admin-tool.html',
          getLoginUrl: function(redirectURL) {
            return buildLoginUrl('/vCas/login', '/kiosk-workflows/admin/j_spring_cas_security_check', redirectURL);
          },
          logoutUrl: '/kiosk-workflows/admin/logout.do',
          i18nBundle: 'javascript-staff-messages',
          staticMessagesPath: '/static-content/i18n/content/',
          uawContext: '/useradmin'
        },
        ADMIN_TOOL_INDEX: {
          name: 'ADMIN_TOOL_INDEX',
          context: 'kiosk-workflows',
          baseRestUrl: '/kiosk-workflows/ws',
          baseSecureRestUrl: '/kiosk-workflows/ws',
          urlPath: '/admin/index.do',
          getLoginUrl: function(redirectURL) {
            return buildLoginUrl('/vCas/login', '/kiosk-workflows/admin/j_spring_cas_security_check', redirectURL);
          },
          logoutUrl: '/kiosk-workflows/admin/logout.do',
          i18nBundle: 'javascript-staff-messages',
          staticMessagesPath: '/static-content/i18n/content/',
          uawContext: '/useradmin'
        },
        DATA_GENERATOR: {
          name: 'DATA_GENERATOR',
          context: 'data-generator',
          baseRestUrl: '/kiosk-workflows/ws',
          baseSecureRestUrl: '/kiosk-workflows/ws',
          urlPath: '/admin-tool.html',
          getLoginUrl: function(redirectURL) {
            return buildLoginUrl('/vCas/login', '/kiosk-workflows/admin/j_spring_cas_security_check', redirectURL);
          },
          logoutUrl: '/kiosk-workflows/admin/logout.do',
          i18nBundle: 'javascript-staff-messages',
          staticMessagesPath: '/static-content/i18n/content/',
          uawContext: '/useradmin'
        },
        DESIGN_DEMO: {
          name: 'DESIGN_DEMO',
          context: 'design-demo',
          baseRestUrl: '/design',
          baseSecureRestUrl: '/design/secure',
          urlPath: 'design-demo.html',
          i18nBundle: 'javascript-demo-messages',
          staticMessagesPath: 'i18n/content/',
          uawContext: '/useradmin',
          noStaticContentServer: true,
          mockCreditCardEncryption: true
        },
        PATIENT_PORTAL: {
          name: 'PATIENT_PORTAL',
          context: 'patient-portal',
          baseRestUrl: '/patient-portal/rest',
          baseSecureRestUrl: '/patient-portal/rest/secure',
          urlPath: '/patient.html',
          getLoginUrl: function(redirectURL) {
            return buildLoginUrl('/vCas-portal/login', '/patient-portal/login/j_spring_cas_security_check', redirectURL);
          },
          logoutUrl: '/patient-portal/logout.do',
          i18nBundle: 'javascript-patient-messages',
          staticMessagesPath: '/static-content/i18n/content/',
          uawContext: '/uaw-portal'
        },
        EREG: {
          name: 'EREG',
          context: 'patient-portal',
          baseRestUrl: '/patient-portal/rest',
          baseSecureRestUrl: '/patient-portal/rest/secure',
          urlPath: '/ereg.html',
          getLoginUrl: function(serialNumber) {
            return '/patient-portal/ereg.html#tablet/serialNumber/' + serialNumber;
          },
          logoutUrl: '/patient-portal/logout.do?isEregLogout=true',
          i18nBundle: 'javascript-patient-messages',
          staticMessagesPath: '/static-content/i18n/content/',
          uawContext: '/uaw-portal'
        },
        QCP: {
          name: 'QCP',
          context: 'qcworks',
          baseRestUrl: '/qcworks/services',
          baseSecureRestUrl: '/qcworks/services/secure',
          urlPath: 'pathfinder/frontend.do',
          loginUrl: '/',
          logoutUrl: '/logout.do',
          i18nBundle: 'qcp-frontend-i18n',
          staticMessagesPath: '/qcworks/',
          uawContext: '/uaw-qcp'
        },
        VCC: {
          name: 'VCC',
          context: 'patient-portal',
          baseRestUrl: '/patient-portal/rest',
          baseSecureRestUrl: '/patient-portal/rest/secure',
          urlPath: '/portal.html',
          logoutUrl: '/patient-portal/logout.do',
          i18nBundle: 'javascript-patient-messages',
          staticMessagesPath: '/static-content/i18n/content/',
          uawContext: '/uaw-portal'
        },
        JASMINE_TESTS: {
          name: 'JASMINE_TESTS',
          context: 'jasmine-tests',
          baseRestUrl: '/jasmine-tests/ws',
          baseSecureRestUrl: '/jasmine-tests/ws/secure',
          urlPath: '/context.html',
          debugUrlPath: '/debug.html',
          i18nBundle: 'javascript-frontend-messages',
          staticMessagesPath: '/base/app/i18n/',
          uawContext: '/useradmin',
          noStaticContentServer: true,
          skipI18nInitialization: true,
          mockCreditCardEncryption: true
        }
      };

    _.each(APPLICATIONS, function(application) {
      if (application.name === APPLICATIONS.DESIGN_DEMO.name) {
        application.fullUrlPath = application.urlPath;
      } else {
        application.fullUrlPath = '/' + application.context + application.urlPath;
      }
    });

  /**
   * Calculates the current application from APPLICATIONS based on the current window location.
   * @returns {APPLICATIONS.PATIENT_PORTAL|{name, context, baseRestUrl, baseSecureRestUrl}}
   */
  function getCurrentApplication() {
    var currentApplication = APPLICATIONS.PATIENT_PORTAL; // default for .js unit tests.

    // There are now 2 admin tool pages and 2 patient-portal pages with the same context.
    // Removing ADMIN_TOOL_INDEX, VCC and EREG from the applicationContext map since they are under the same context
    //   as other applications and we're checking them separately later.
    var applicationContexts = _.filter(APPLICATIONS, function(applicationContext) {
      return applicationContext.name !== 'ADMIN_TOOL_INDEX' && applicationContext.name !== 'EREG' && applicationContext.name !== 'VCC';
    });

    var contextToApplicationArray = _.map(applicationContexts, function(applicationContext) {
      return [applicationContext.context, applicationContext];
    });

    var CONTEXT_TO_APPLICATION_PROPERTIES = _.object(contextToApplicationArray);
    var pathWithoutLeadingSlash = window.location.pathname.slice(1);
    var pathParts = pathWithoutLeadingSlash.split('/');
    var contextPart = pathParts[0];

    currentApplication = CONTEXT_TO_APPLICATION_PROPERTIES[contextPart] || currentApplication;

    // The 3 patient portal pages are ereg.html, portal.html and patient.html.  The checks below disambiguate them.
    if (currentApplication.context === 'patient-portal') {
      var isEreg = pathWithoutLeadingSlash.indexOf(APPLICATIONS.EREG.urlPath) > 0;
      if (isEreg) {
        currentApplication = APPLICATIONS.EREG;
      }
      var isVcc = pathWithoutLeadingSlash.indexOf(APPLICATIONS.VCC.urlPath) > 0;
      if (isVcc) {
        currentApplication = APPLICATIONS.VCC;
      }
      // Design Demo works a little differently for being able to deploy it standalone.
      // You'll end up with a URL akin to http://127.0.0.1:8081/design-demo.html.
      // This would fail, resulting in it reading as Patient_Portal, if
      //   a) the APPLICATION.DESIGN_DEMO.urlPath had a forward slash at the beginning
      //   b) we were checking against 0 instead of -1.
      var isDesign = pathWithoutLeadingSlash.indexOf(APPLICATIONS.DESIGN_DEMO.urlPath) > -1;
      if (isDesign) {
        currentApplication = APPLICATIONS.DESIGN_DEMO;
      }
      var isJasmineTest = APPLICATIONS.JASMINE_TESTS.urlPath.indexOf(pathWithoutLeadingSlash) > 0;
      if (isJasmineTest) {
        currentApplication = APPLICATIONS.JASMINE_TESTS;
      }
      var isDebugJasmineTest = APPLICATIONS.JASMINE_TESTS.debugUrlPath.indexOf(pathWithoutLeadingSlash) > 0;
      if (isDebugJasmineTest) {
        currentApplication = APPLICATIONS.JASMINE_TESTS;
        currentApplication.urlPath = APPLICATIONS.JASMINE_TESTS.debugUrlPath;
      }
    }

    // The 2 admin tool pages are index.do and admin-tool.html.  Since those are url paths we just need to check whether the
    // url contains index.do (isAdminToolIndex), otherwise it is the other old one.
    var isAdminToolIndex = currentApplication.context === 'kiosk-workflows' && pathWithoutLeadingSlash.indexOf(APPLICATIONS.ADMIN_TOOL_INDEX.urlPath) > 0;
    if (isAdminToolIndex) {
      currentApplication = APPLICATIONS.ADMIN_TOOL_INDEX;
    }

    return currentApplication;
  }

  /**
   * @param link {String} the link to check.
   * @returns {Boolean} true if the link starts with any of the contexts in APPLICATIONS.
   */
  function linkStartsWithAnyContext(link) {
    var allContexts = _.pluck(APPLICATIONS, 'context');
    return _.find(allContexts, function(arrayValue) {
      return stringUtils.startsWith(link, arrayValue);
    });
  }

  return {
    /**
     * url information for the detected application.
     * @property currentApplication {Object}
     *   @property currentApplication.name {String} the name of this context, also the property name in APPLICATIONS.
     *   @property currentApplication.context {String} the url context of this application.
     *   @property currentApplication.baseRestUrl {String} the url to use for non-secure services.
     *   @property currentApplication.baseSecureRestUrl {String} the url to use for secure services.
     */
    currentApplication: getCurrentApplication(),
    /**
     * map from application name (ADMIN_TOOL, PATIENT_PORTAL) to path info related to that application.
     * @property APPLICATIONS {Object}
     *   @property APPLICATIONS.ADMIN_TOOL {Object} url information for admin tool.
     *     @property APPLICATIONS.ADMIN_TOOL.name='ADMIN_TOOL' {String} the name of this context, also the property name in APPLICATIONS.
     *     @property APPLICATIONS.ADMIN_TOOL.context='kiosk-workflows' {String} the context of the admin tool.
     *     @property APPLICATIONS.ADMIN_TOOL.baseRestUrl='/kiosk-workflows/ws' {String} the url to use for non-secure services.
     *     @property APPLICATIONS.ADMIN_TOOL.baseSecureRestUrl='/kiosk-workflows/ws' {String} the url to use for secure services.
     *   @property APPLICATIONS.PATIENT_PORTAL {Object} url information for patient-portal.
     *     @property APPLICATIONS.ADMIN_TOOL.name='PATIENT_PORTAL' {String} the name of this context, also the property name in APPLICATIONS.
     *     @property APPLICATIONS.PATIENT_PORTAL.context='patient-portal' {String} the context of the patient-portal.
     *     @property APPLICATIONS.PATIENT_PORTAL.baseRestUrl='/patient-portal/rest' {String} the url to use for non-secure services.
     *     @property APPLICATIONS.PATIENT_PORTAL.baseSecureRestUrl='/patient-portal/rest/secure' {String} the url to use for secure services.
     */
    APPLICATIONS: APPLICATIONS,

    /**
     * Tests whether the given link points inside of our known applications.
     * @method isInternalLink
     * @param link {String} the link to check.
     * @returns {Boolean} true if the link is a known internal link.
     *                    An internal link is defined by either the Contexts in APPLICATIONS or is a relative path or hash.
     */
    isInternalLink: function(link) {
      var startsWithAnyContext = linkStartsWithAnyContext(link),
          isRelativePath = stringUtils.startsWith(link, '/'),
          isRelativeHash = stringUtils.startsWith(link, '#');

      return startsWithAnyContext || isRelativeHash || isRelativePath;
    },

    /**
     * map from authentication context (SPA, CAS) to a string representing the context.
     * @property AUTHENTICATION_CONTEXTS {Object}
     *   @property AUTHENTICATION_CONTEXTS.SPA {String} 'SPA' context - use the SPA login screen.
     *   @property AUTHENTICATION_CONTEXTS.CAS {String} 'CAS' context - redirect to CAS for the login screen..
     */
    AUTHENTICATION_CONTEXTS: {
      SPA: 'SPA',
      CAS: 'CAS'
    }
  };
}));
